<template>
    <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
</template>

<script>
import ProcessosServicos from './ProcessosServicos'

export default {
    data() {
        return {
            contrato: {},
            erros: []
        }
    },

    methods: {
        obterContratoGestor() {
            this.$store.dispatch('addRequest')
            let contratoId = this.$route.query.c
            ProcessosServicos.obterContratoGestor(contratoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.contrato = response.data
                        this.confirmarFinalizarAvisosContratoSemMovimentacao()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarFinalizarAvisosContratoSemMovimentacao() {
            this.$swal({
                title: 'Avisos de Contrato Sem Movimentação',
                html: `Confirma a finalização dos avisos de "Sem Movimentação" do contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.finalizarAvisosContratoSemMovimentacao(result.value)
                } else {
                    this.$router.push('/')
                }
            })
        },

        finalizarAvisosContratoSemMovimentacao() {
            this.$store.dispatch('addRequest')
            ProcessosServicos.finalizarAvisosContratoSemMovimentacao(
                this.$route.query.c
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.finalizacaoRealizadaComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        finalizacaoRealizadaComSucesso() {
            this.$swal({
                title: 'Avisos de Contrato Sem Movimentação',
                html: `Finalizados com Sucesso`,
                icon: 'success'
            }).then(result => {
                if (result.value) {
                    this.$router.push('/')
                }
            })
        }
    },

    created() {
        this.obterContratoGestor()
    }
}
</script>
